import { TWaterfallDiversificacion } from "../../../services/OmniaService";
import { TDiversCartWaterfallModel } from "../../Portfolios/File/types/DiversificacionCarteraTypes";

export const FormatWaterfallModel = (waterfallRawData: TWaterfallDiversificacion[]) : TDiversCartWaterfallModel[] => {
    return waterfallRawData.map(item => {       
        return {
            tipoActivo: item.tipo_activo,
            valor: item.valor
        }
    })
};